function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function e(e) {
  return e && "object" == _typeof(e) && "default" in e ? e.default : e;
}

var t = e(require("axios")),
    n = e(require("qs")),
    i = e(require("deepmerge"));

function o() {
  return (o = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var i in n) {
        Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
      }
    }

    return e;
  }).apply(this, arguments);
}

var r = {
  modal: null,
  listener: null,
  show: function show(e) {
    var t = this;
    "object" == _typeof(e) && (e = "All Inertia requests must receive a valid Inertia response, however a plain JSON response was received.<hr>" + JSON.stringify(e));
    var n = document.createElement("html");
    n.innerHTML = e, n.querySelectorAll("a").forEach(function (e) {
      return e.setAttribute("target", "_top");
    }), this.modal = document.createElement("div"), this.modal.style.position = "fixed", this.modal.style.width = "100vw", this.modal.style.height = "100vh", this.modal.style.padding = "50px", this.modal.style.boxSizing = "border-box", this.modal.style.backgroundColor = "rgba(0, 0, 0, .6)", this.modal.style.zIndex = 2e5, this.modal.addEventListener("click", function () {
      return t.hide();
    });
    var i = document.createElement("iframe");
    i.style.backgroundColor = "white", i.style.borderRadius = "5px", i.style.width = "100%", i.style.height = "100%", this.modal.appendChild(i), document.body.prepend(this.modal), document.body.style.overflow = "hidden", i.contentWindow.document.open(), i.contentWindow.document.write(n.outerHTML), i.contentWindow.document.close(), this.listener = this.hideOnEscape.bind(this), document.addEventListener("keydown", this.listener);
  },
  hide: function hide() {
    this.modal.outerHTML = "", this.modal = null, document.body.style.overflow = "visible", document.removeEventListener("keydown", this.listener);
  },
  hideOnEscape: function hideOnEscape(e) {
    27 === e.keyCode && this.hide();
  }
};

function s(e, t) {
  return document.dispatchEvent(new CustomEvent("inertia:" + e, t));
}

function a(e) {
  return s("finish", {
    detail: {
      visit: e
    }
  });
}

function l(e) {
  return s("navigate", {
    detail: {
      page: e
    }
  });
}

function c(e) {
  return new URL(e, window.location);
}

function d(e, t, o) {
  return "get" === e && Object.keys(o).length && (t.search = n.stringify(i(n.parse(t.search, {
    ignoreQueryPrefix: !0
  }), o), {
    encodeValuesOnly: !0,
    arrayFormat: "brackets"
  }), o = {}), [t, o];
}

function u(e) {
  return (e = new URL(e.href)).hash = "", e;
}

function h(e, t, n) {
  if (void 0 === t && (t = new FormData()), void 0 === n && (n = null), null === e || "undefined" === e || 0 === e.length) return t.append(n, e);

  for (var i in e) {
    Object.prototype.hasOwnProperty.call(e, i) && v(t, p(n, i), e[i]);
  }

  return t;
}

function p(e, t) {
  return e ? e + "[" + t + "]" : t;
}

function v(e, t, n) {
  return n instanceof Date ? e.append(t, n.toISOString()) : n instanceof File ? e.append(t, n, n.name) : "boolean" == typeof n ? e.append(t, n ? "1" : "0") : null === n ? e.append(t, "") : "object" != _typeof(n) ? e.append(t, n) : void h(n, e, t);
}

exports.Inertia = {
  resolveComponent: null,
  resolveErrors: function resolveErrors(e) {
    return e.props.errors || {};
  },
  swapComponent: null,
  transformProps: function transformProps(e) {
    return e;
  },
  activeVisit: null,
  visitId: null,
  page: null,
  init: function init(e) {
    var t = e.initialPage,
        n = e.resolveErrors,
        i = e.swapComponent,
        o = e.transformProps;
    this.resolveComponent = e.resolveComponent, this.resolveErrors = n || this.resolveErrors, this.swapComponent = i, this.transformProps = o || this.transformProps, this.handleInitialPageVisit(t), this.setupEventListeners();
  },
  handleInitialPageVisit: function handleInitialPageVisit(e) {
    this.isBackForwardVisit() ? this.handleBackForwardVisit(e) : this.isLocationVisit() ? this.handleLocationVisit(e) : (e.url += window.location.hash, this.setPage(e)), l(e);
  },
  setupEventListeners: function setupEventListeners() {
    var e, t;
    window.addEventListener("popstate", this.handlePopstateEvent.bind(this)), document.addEventListener("scroll", (e = this.handleScrollEvent.bind(this), t = null, function () {
      var n = arguments,
          i = this;
      clearTimeout(t), t = setTimeout(function () {
        return e.apply(i, n);
      }, 100);
    }), !0);
  },
  scrollRegions: function scrollRegions() {
    return document.querySelectorAll("[scroll-region]");
  },
  handleScrollEvent: function handleScrollEvent(e) {
    "function" == typeof e.target.hasAttribute && e.target.hasAttribute("scroll-region") && this.saveScrollPositions();
  },
  saveScrollPositions: function saveScrollPositions() {
    this.replaceState(o({}, this.page, {
      scrollRegions: Array.prototype.slice.call(this.scrollRegions()).map(function (e) {
        return {
          top: e.scrollTop,
          left: e.scrollLeft
        };
      })
    }));
  },
  resetScrollPositions: function resetScrollPositions() {
    var e;
    document.documentElement.scrollTop = 0, document.documentElement.scrollLeft = 0, this.scrollRegions().forEach(function (e) {
      e.scrollTop = 0, e.scrollLeft = 0;
    }), this.saveScrollPositions(), window.location.hash && (null == (e = document.getElementById(window.location.hash.slice(1))) || e.scrollIntoView());
  },
  restoreScrollPositions: function restoreScrollPositions() {
    var e = this;
    this.page.scrollRegions && this.scrollRegions().forEach(function (t, n) {
      t.scrollTop = e.page.scrollRegions[n].top, t.scrollLeft = e.page.scrollRegions[n].left;
    });
  },
  isBackForwardVisit: function isBackForwardVisit() {
    return window.history.state && window.performance && window.performance.getEntriesByType("navigation").length && "back_forward" === window.performance.getEntriesByType("navigation")[0].type;
  },
  handleBackForwardVisit: function handleBackForwardVisit(e) {
    var t = this;
    window.history.state.version = e.version, this.setPage(window.history.state, {
      preserveScroll: !0
    }).then(function () {
      t.restoreScrollPositions();
    });
  },
  locationVisit: function locationVisit(e, t) {
    try {
      window.sessionStorage.setItem("inertiaLocationVisit", JSON.stringify({
        preserveScroll: t
      })), window.location.href = e.href, u(window.location).href === u(e).href && window.location.reload();
    } catch (e) {
      return !1;
    }
  },
  isLocationVisit: function isLocationVisit() {
    try {
      return null !== window.sessionStorage.getItem("inertiaLocationVisit");
    } catch (e) {
      return !1;
    }
  },
  handleLocationVisit: function handleLocationVisit(e) {
    var t,
        n,
        i,
        o,
        r = this,
        s = JSON.parse(window.sessionStorage.getItem("inertiaLocationVisit"));
    window.sessionStorage.removeItem("inertiaLocationVisit"), e.url += window.location.hash, e.rememberedState = null != (t = null == (n = window.history.state) ? void 0 : n.rememberedState) ? t : {}, e.scrollRegions = null != (i = null == (o = window.history.state) ? void 0 : o.scrollRegions) ? i : [], this.setPage(e, {
      preserveScroll: s.preserveScroll
    }).then(function () {
      s.preserveScroll && r.restoreScrollPositions();
    });
  },
  isLocationVisitResponse: function isLocationVisitResponse(e) {
    return e && 409 === e.status && e.headers["x-inertia-location"];
  },
  isInertiaResponse: function isInertiaResponse(e) {
    return null == e ? void 0 : e.headers["x-inertia"];
  },
  createVisitId: function createVisitId() {
    return this.visitId = {}, this.visitId;
  },
  cancelVisit: function cancelVisit(e, t) {
    var n = t.cancelled,
        i = void 0 !== n && n,
        o = t.interrupted,
        r = void 0 !== o && o;
    !e || e.completed || e.cancelled || e.interrupted || (e.cancelToken.cancel(), e.onCancel(), e.completed = !1, e.cancelled = i, e.interrupted = r, a(e), e.onFinish(e));
  },
  finishVisit: function finishVisit(e) {
    e.cancelled || e.interrupted || (e.completed = !0, e.cancelled = !1, e.interrupted = !1, a(e), e.onFinish(e));
  },
  visit: function visit(e, n) {
    var i = this,
        a = void 0 === n ? {} : n,
        l = a.method,
        p = void 0 === l ? "get" : l,
        v = a.data,
        f = void 0 === v ? {} : v,
        m = a.replace,
        g = void 0 !== m && m,
        w = a.preserveScroll,
        y = void 0 !== w && w,
        S = a.preserveState,
        b = void 0 !== S && S,
        P = a.only,
        I = void 0 === P ? [] : P,
        E = a.headers,
        V = void 0 === E ? {} : E,
        L = a.errorBag,
        C = void 0 === L ? null : L,
        k = a.forceFormData,
        x = void 0 !== k && k,
        R = a.onCancelToken,
        T = void 0 === R ? function () {
      return {};
    } : R,
        O = a.onBefore,
        j = void 0 === O ? function () {
      return {};
    } : O,
        F = a.onStart,
        B = void 0 === F ? function () {
      return {};
    } : F,
        q = a.onProgress,
        A = void 0 === q ? function () {
      return {};
    } : q,
        D = a.onFinish,
        N = void 0 === D ? function () {
      return {};
    } : D,
        X = a.onCancel,
        J = void 0 === X ? function () {
      return {};
    } : X,
        H = a.onSuccess,
        M = void 0 === H ? function () {
      return {};
    } : H,
        W = a.onError,
        K = void 0 === W ? function () {
      return {};
    } : W,
        U = d(p = p.toLowerCase(), c(e), f);
    e = U[0];

    var z = function e(t) {
      return t instanceof File || t instanceof FileList || "object" == _typeof(t) && null !== t && void 0 !== Object.values(t).find(function (t) {
        return e(t);
      });
    }(f = U[1]);

    "get" !== p && (z || x) && (f = h(f));
    var Q = {
      url: e,
      method: p,
      data: f,
      replace: g,
      preserveScroll: y,
      preserveState: b,
      only: I,
      headers: V,
      errorBag: C,
      forceFormData: x,
      onCancelToken: T,
      onBefore: j,
      onStart: B,
      onProgress: A,
      onFinish: N,
      onCancel: J,
      onSuccess: M,
      onError: K
    };

    if (!1 !== j(Q) && function (e) {
      return s("before", {
        cancelable: !0,
        detail: {
          visit: e
        }
      });
    }(Q)) {
      this.cancelVisit(this.activeVisit, {
        interrupted: !0
      }), this.saveScrollPositions();

      var _ = this.createVisitId();

      return this.activeVisit = Q, this.activeVisit.cancelToken = t.CancelToken.source(), T({
        cancel: function cancel() {
          return i.cancelVisit(i.activeVisit, {
            cancelled: !0
          });
        }
      }), function (e) {
        s("start", {
          detail: {
            visit: e
          }
        });
      }(Q), B(Q), new Proxy(t({
        method: p,
        url: u(e).href,
        data: "get" === p ? {} : f,
        params: "get" === p ? f : {},
        cancelToken: this.activeVisit.cancelToken.token,
        headers: o({}, V, {
          Accept: "text/html, application/xhtml+xml",
          "X-Requested-With": "XMLHttpRequest",
          "X-Inertia": !0
        }, I.length ? {
          "X-Inertia-Partial-Component": this.page.component,
          "X-Inertia-Partial-Data": I.join(",")
        } : {}, C ? {
          "X-Inertia-Error-Bag": C
        } : {}, this.page.version ? {
          "X-Inertia-Version": this.page.version
        } : {}),
        onUploadProgress: function onUploadProgress(e) {
          z && (e.percentage = Math.round(e.loaded / e.total * 100), function (e) {
            s("progress", {
              detail: {
                progress: e
              }
            });
          }(e), A(e));
        }
      }).then(function (t) {
        var n;
        if (!i.isInertiaResponse(t)) return Promise.reject({
          response: t
        });
        I.length && t.data.component === i.page.component && (t.data.props = o({}, i.page.props, t.data.props)), b && null != (n = window.history.state) && n.rememberedState && t.data.component === i.page.component && (t.data.rememberedState = window.history.state.rememberedState);
        var r = c(t.data.url);
        return e.hash && !r.hash && u(e).href === r.href && (r.hash = e.hash, t.data.url = r.href), i.setPage(t.data, {
          visitId: _,
          replace: g,
          preserveScroll: y,
          preserveState: b
        });
      }).then(function () {
        var e = i.resolveErrors(i.page);
        return Object.keys(e).length > 0 ? (function (e) {
          s("error", {
            detail: {
              errors: e
            }
          });
        }(e[C] || e), K(e[C] || e)) : (s("success", {
          detail: {
            page: i.page
          }
        }), M(i.page));
      }).catch(function (t) {
        if (i.isInertiaResponse(t.response)) return i.setPage(t.response.data, {
          visitId: _
        });

        if (i.isLocationVisitResponse(t.response)) {
          var n = c(t.response.headers["x-inertia-location"]);
          e.hash && !n.hash && u(e).href === n.href && (n.hash = e.hash), i.locationVisit(n, y);
        } else {
          if (!t.response) return Promise.reject(t);
          s("invalid", {
            cancelable: !0,
            detail: {
              response: t.response
            }
          }) && r.show(t.response.data);
        }
      }).then(function () {
        i.finishVisit(Q);
      }).catch(function (e) {
        if (!t.isCancel(e)) {
          var n = s("exception", {
            cancelable: !0,
            detail: {
              exception: e
            }
          });
          if (i.finishVisit(Q), n) return Promise.reject(e);
        }
      }), {
        get: function get(e, t) {
          return ["then", "catch", "finally"].includes(t) && console.warn("Inertia.js visit promises have been deprecated and will be removed in a future release. Please use the new visit event callbacks instead.\n\nLearn more at https://inertiajs.com/manual-visits#promise-deprecation"), "function" == typeof e[t] ? e[t].bind(e) : e[t];
        }
      });
    }
  },
  setPage: function setPage(e, t) {
    var n = this,
        i = void 0 === t ? {} : t,
        o = i.visitId,
        r = void 0 === o ? this.createVisitId() : o,
        s = i.replace,
        a = void 0 !== s && s,
        d = i.preserveScroll,
        u = void 0 !== d && d,
        h = i.preserveState,
        p = void 0 !== h && h;
    return Promise.resolve(this.resolveComponent(e.component)).then(function (t) {
      if (r === n.visitId) {
        e.scrollRegions = e.scrollRegions || [], e.rememberedState = e.rememberedState || {}, p = "function" == typeof p ? p(e) : p, u = "function" == typeof u ? u(e) : u, (a = a || c(e.url).href === window.location.href) ? n.replaceState(e) : n.pushState(e);
        var i = JSON.parse(JSON.stringify(e));
        i.props = n.transformProps(i.props), n.swapComponent({
          component: t,
          page: i,
          preserveState: p
        }).then(function () {
          u || n.resetScrollPositions(), a || l(e);
        });
      }
    });
  },
  pushState: function pushState(e) {
    this.page = e, window.history.pushState(e, "", e.url);
  },
  replaceState: function replaceState(e) {
    this.page = e, window.history.replaceState(e, "", e.url);
  },
  handlePopstateEvent: function handlePopstateEvent(e) {
    var t = this;

    if (null !== e.state) {
      var n = e.state,
          i = this.createVisitId();
      return Promise.resolve(this.resolveComponent(n.component)).then(function (e) {
        i === t.visitId && (t.page = n, t.swapComponent({
          component: e,
          page: n,
          preserveState: !1
        }).then(function () {
          t.restoreScrollPositions(), l(n);
        }));
      });
    }

    var r = c(this.page.url);
    r.hash = window.location.hash, this.replaceState(o({}, this.page, {
      url: r.href
    })), this.resetScrollPositions();
  },
  get: function get(e, t, n) {
    return void 0 === t && (t = {}), void 0 === n && (n = {}), this.visit(e, o({}, n, {
      method: "get",
      data: t
    }));
  },
  reload: function reload(e) {
    return void 0 === e && (e = {}), this.visit(window.location.href, o({}, e, {
      preserveScroll: !0,
      preserveState: !0
    }));
  },
  replace: function replace(e, t) {
    var n;
    return void 0 === t && (t = {}), console.warn("Inertia.replace() has been deprecated and will be removed in a future release. Please use Inertia." + (null != (n = t.method) ? n : "get") + "() instead."), this.visit(e, o({
      preserveState: !0
    }, t, {
      replace: !0
    }));
  },
  post: function post(e, t, n) {
    return void 0 === t && (t = {}), void 0 === n && (n = {}), this.visit(e, o({
      preserveState: !0
    }, n, {
      method: "post",
      data: t
    }));
  },
  put: function put(e, t, n) {
    return void 0 === t && (t = {}), void 0 === n && (n = {}), this.visit(e, o({
      preserveState: !0
    }, n, {
      method: "put",
      data: t
    }));
  },
  patch: function patch(e, t, n) {
    return void 0 === t && (t = {}), void 0 === n && (n = {}), this.visit(e, o({
      preserveState: !0
    }, n, {
      method: "patch",
      data: t
    }));
  },
  delete: function _delete(e, t) {
    return void 0 === t && (t = {}), this.visit(e, o({
      preserveState: !0
    }, t, {
      method: "delete"
    }));
  },
  remember: function remember(e, t) {
    var n;
    void 0 === t && (t = "default"), this.replaceState(o({}, this.page, {
      rememberedState: o({}, this.page.rememberedState, (n = {}, n[t] = e, n))
    }));
  },
  restore: function restore(e) {
    var t, n;
    return void 0 === e && (e = "default"), null == (t = window.history.state) || null == (n = t.rememberedState) ? void 0 : n[e];
  },
  on: function on(e, t) {
    var n = function n(e) {
      var n = t(e);
      e.cancelable && !e.defaultPrevented && !1 === n && e.preventDefault();
    };

    return document.addEventListener("inertia:" + e, n), function () {
      return document.removeEventListener("inertia:" + e, n);
    };
  }
}, exports.hrefToUrl = c, exports.mergeDataIntoQueryString = d, exports.shouldIntercept = function (e) {
  var t = "a" === e.currentTarget.tagName.toLowerCase();
  return !(e.target && e.target.isContentEditable || e.defaultPrevented || t && e.which > 1 || t && e.altKey || t && e.ctrlKey || t && e.metaKey || t && e.shiftKey);
}, exports.urlWithoutHash = u;